<template>
  <Layout />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Layout from '@/components/Layout'

export default defineComponent({
  components: {
    Layout
  }
})
</script>

<style>
.van-toast__text {
  padding: 10px 5px;
  font-size: 15px;
  line-height: 18px;
}
</style>
